import Resources from '@/views/Resources.vue'
import ResourcesSidebar from '@/modules/resources/ResourcesSidebar.vue'
import ImageResourceDetails from '@/modules/resources/ImageResourceDetails.vue'

import { RESOURCES_STORE_NAMESPACE } from '@/modules/resources/resourcesStore'

export default [
  {
    path: '/resources',
    component: Resources,

    children: [
      {
        path: '',
        name: 'resourcesSidebar',
        components: {
          master: ResourcesSidebar
        },

        props: {
          master: {
            resourcesStorePath: RESOURCES_STORE_NAMESPACE
          }
        }
      },
      {
        path: ':resourceId',
        name: 'imageResourceDetails',
        components: {
          master: ResourcesSidebar,
          details: ImageResourceDetails
        },

        props: {
          master: {
            resourcesStorePath: RESOURCES_STORE_NAMESPACE
          },
          details: route => ({
            resourcesStorePath: RESOURCES_STORE_NAMESPACE,
            resourceId: route.params.resourceId
          })
        }
      }
    ]
  }
]
